"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = require("./index");
var _client = _interopRequireDefault(require("./client"));
var _default = exports.default = function _default(err) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'info';
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var Sentry = arguments.length > 3 ? arguments[3] : undefined;
  try {
    var _window$__PAGE_META__;
    var client = (0, _client.default)() || '未知';
    var userId = (0, _index.getCookie)('uid') || (0, _index.getCookie)('sso_uid') || 'nofound';
    var errObj = null;
    if (err instanceof Error) {
      errObj = err;
    } else if (err instanceof Object) {
      if (err.respMsg || err.errorMsg || err.errMsg || err.respData || err.respCode) {
        errObj = new Error(err.respMsg || err.errorMsg || err.errMsg || '网络异常');
      } else {
        errObj = new Error(JSON.stringify(err));
      }
    } else if (typeof err === 'string') {
      errObj = new Error(err);
    }
    var errorType = '提示';
    var myLevel = type || 'info';
    switch (type) {
      case 'error':
        // --- 新等级规则 error
        errorType = '严重';
        myLevel = 'error';
        break;
      case 'warning':
        // --- 新等级规则 warning
        errorType = '警告';
        myLevel = 'warning';
        break;
      case 'info':
        // --- 新等级规则 info
        errorType = '提示';
        myLevel = 'info';
        break;
      default:
        myLevel = 'info';
        errorType = '提示';
        break;
    }

    // tag信息，辅助快速定位错误
    var t = (0, _index.getCookie)('zz_t') || (0, _index.getCookie)('t') || '';
    var ua = navigator.userAgent.match(/zzVersion\/(.*?)\s/) ? navigator.userAgent.match(/zzVersion\/(.*?)\s/)[1] : '';
    var version = (0, _index.getCookie)('v') || ua;
    var errorMessage = errObj && errObj.message;
    var tagsDefault = {
      errorType: errorType,
      client: client,
      errInfo: errorMessage,
      env: process.env.NODE_ENV || '未知',
      t: t,
      version: version,
      myLevel: myLevel,
      // 枚举：error waring info
      level: myLevel,
      tVersion: "".concat(t, " ").concat(version),
      uid: userId || '未知',
      tel: (0, _index.getCookie)('tel') || ''
    };
    var extraDefault = {
      UA: navigator.userAgent
    };
    var isTesting = window['__PAGE_META__'] && ((_window$__PAGE_META__ = window['__PAGE_META__']) === null || _window$__PAGE_META__ === void 0 ? void 0 : _window$__PAGE_META__.env) == 'testing'; // 测试和沙箱环境不上报
    if (isTesting) return;
    if (typeof location !== 'undefined') {
      tagsDefault.route = location.hash && location.hash.replace(/(#)([^\?]*)(\?.*)*/g, '$2') || location.href;
    }

    // 主动上报过滤信息：过滤异步库-业务接口提示(和自动上报重复发)
    var canCaptureExcept = errorMessage && !(errorMessage.indexOf('v-on handler (Promise/async)') > -1);
    var tags = Object.assign(tagsDefault, opts.tags || {});
    var extra = Object.assign(extraDefault, opts.extra || {});
    var fingerprint = [process.env.NODE_ENV, errorType, errorMessage];
    var other = {
      message: errorMessage,
      tags: tags,
      extra: extra,
      fingerprint: fingerprint
    };

    // 拦截cookie异常项
    if (canCaptureExcept) {
      // 主动发送错误
      if (client === '小程序') {
        Sentry.captureException(errObj, other);
      } else {
        Sentry.withScope(function (scope) {
          scope.setTags(tags);
          if (['info', 'error', 'warning'].includes(myLevel)) {
            // 原来的等级：fatal 致命；error 严重；warning 警告；info 提示 =》 对应现在三个 error、warning和info
            scope.setLevel(myLevel);
          }
          scope.setExtras(extra); // 主动上报时，不这么加其他参数无法合并
          Sentry.captureException(errObj, other);
        });
      }
    }
  } catch (err) {
    console.warn('sentry主动捕获 异常', err);
  }
};